module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    },
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "prologue-1"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("A week later, Jan had the chance to replace a dismissed sailor on the larger of the two ships under Tasman’s command. The "), _c('em', [_vm._v("Heemskerck")]), _vm._v(" was a four year old, three-mast war-yacht of three hundred tons, with a crew of sixty looking after twice that many guns. The ship was about to leave, together with the smaller, three-year old transport ship "), _c('em', [_vm._v("Zeehaen")]), _vm._v(", with fifty men on board, on a mission to discover more of the mysterious Southland. Jan had only vaguely heard of the place but as the skipper of the "), _c('em', [_vm._v("Heemskerck")]), _vm._v(" was a Frisian seadog and Tasman had the reputation of having explored places in eastern Asia as far north as Japan, he had signed on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("They left the quay at Batavia on 14 August 1642 and for almost three hundred days did not return. Initially they had sailed west, to islands off the east coast of Africa. The first mate explained that from there they would sail south, to catch the trade winds blowing east. For many days they crossed one meridian after the other, sailing ever further. When they finally saw land, Jan volun- teered to be one of the braves going onshore. They saw smoke, of cooking fires they thought, and some had heard sounds and possibly voices, but they did not see people or any signs of habitation. They found tall, strange-smell- ing trees with elongated, hard leaves.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Because he came from a farm, Jan was asked to help look for edible things on land. Others collected fresh water and looked for what lived in a creek and along the shore. That day, and the next, Jan gathered a good many plant species and other things that might be of interest for the records of the expedition. Of the bits he could keep, he treasured a piece of light and oily wood that he had found on the side of a creek, he also kept a twig of the olive-green, smelly leaves, which had some small brown pods attached.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("From time to time, Jan had helped the ship’s carpenter, Pieter Jacobsen, to make repairs. In the Pacific Ocean, when they hit the doldrums and there was nothing to do, Jan asked Pieter if he could use his tools to make a small box from the piece of wood, if only to stop him from getting bored. Pieter said that to be idle was sinful – so yes, he could. Later, they saw new islands and had many adventures, but finally they arrived back in Batavia. They had proved that the mysterious Southland, Terra Australis, was not attached to the South Pole as had been generally believed but that it was an island, because they had sailed around it. Now an experienced sailor, Jan was soon sailing again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("After years at sea Jan thought that enough was enough, and he went home. The money he earned during his wanderings at sea was paid out to him in Amsterdam, where he spent it on wine and women. Back in Groningen, all he could show for his travels was the small box he had made from the wood he found in the Southland. Inside, it still had the leaves with the small brown pods attached. When Jan opened the box, he could still smell the forest of that distant land.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba74c016","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0011.vue
// module id = 93
// module chunks = 0